import React, { useState } from 'react';
import { Card, CardContent, TextField, Button, Typography, Grid } from '@mui/material';

import { RefPlaceholder } from "ag-grid-community";
import { useNavigate } from 'react-router-dom';

const LoginPage= () => {
  // State for username, password, and error messages
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate(); 

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();

    if (!username || !password) {
      setError('Both fields are required');
    } else if (username === 'hotelgst@finkraft.ai' && password === '123') {
      setError('');
      console.log('Username:', username);
      console.log('Password:', password);
      // Redirect to HomePage after successful login
      navigate('/home');;
    } else {
      setError('Invalid username or password');
    }
  };
  return (
    <div
    style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop:'140px'
      }}
    >

      <Card style={{ maxWidth: 400, width: '800px' , height:'400px'}}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Login
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              label="Username"
              fullWidth
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && <Typography color="error">{error}</Typography>}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
              style={{ marginTop: '16px' }}
            >
              Submit
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;

